<script setup>
import HugeIcon from 'dashboard/components-next/icon/HugeIcon.vue';

defineProps({
  title: { type: String, required: true },
  description: { type: String, default: '' },
  subDescription: { type: String, default: '' },
  icon: { type: Object, required: true },
  iconClass: { type: String, default: '' },
  isActive: { type: Boolean, default: false },
  activeCardClass: { type: String, default: '' },
});

defineEmits(['click']);

const ICON_SIZE = 22;
</script>

<template>
  <div
    class="overflow-hidden rounded-xl bg-n-solid-1 shadow-sm transition-shadow hover:shadow-md dark:bg-n-solid-2"
    :class="
      isActive ? activeCardClass : 'border border-n-weak dark:border-n-strong'
    "
  >
    <button
      type="button"
      class="flex w-full flex-col p-0 text-start outline-none"
      :title="description"
      @click="$emit('click')"
    >
      <div class="flex w-full items-center gap-2 px-3 py-2.5">
        <HugeIcon
          :icon="icon"
          :size="ICON_SIZE"
          class="pointer-events-none shrink-0"
          :class="iconClass"
        />
        <span class="text-base font-medium leading-snug text-n-slate-12">{{
          title
        }}</span>
      </div>
      <div
        v-if="description || subDescription"
        role="separator"
        class="block h-px w-full shrink-0 bg-n-weak dark:bg-n-strong"
        aria-hidden="true"
      />
      <div
        v-if="description || subDescription"
        class="flex w-full flex-col gap-1.5 px-3 py-2.5"
      >
        <p v-if="description" class="m-0 text-xs leading-snug text-n-slate-12">
          {{ description }}
        </p>
        <p
          v-if="subDescription"
          class="m-0 text-xs leading-snug text-n-slate-10"
        >
          {{ subDescription }}
        </p>
      </div>
    </button>
  </div>
</template>
